













import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ButtonLocales extends Vue {
  @Prop({ type: String, default: "" }) locale!: string;
  @Prop({ type: String, default: "" }) size!: string;
}
